module.exports = __webpack_public_path__ + "features.f8e9c44a5df5200b6f3d.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/TerrellDavis/Documents/GitHub/AVL/realavl/realavl/src/img/parallax/features.jpg
// module id = ../../../../../src/img/parallax/features.jpg
// module chunks = styles